import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AdmDashboardComponent } from './adm-dashboard/adm-dashboard.component';
import { AdmEmpresasOfdetalleComponent } from './adm-empresas-ofdetalle/adm-empresas-ofdetalle.component';
import { AdmOfertasActivasComponent } from './adm-ofertas-activas/adm-ofertas-activas.component';
import { AdmOfertasDetallesComponent } from './adm-ofertas-detalles/adm-ofertas-detalles.component';
import { AdmOfertasListaComponent } from './adm-ofertas-lista/adm-ofertas-lista.component';
import { AdmEmpresasListaComponent } from './adm-empresas-lista/adm-empresas-lista.component';
import { RouterModule } from '@angular/router';
import { CardModule } from '../partials/general/card/card.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BlockUIModule } from 'ng-block-ui';
import { BlockTemplateComponent } from 'src/app/_layout/blockui/block-template.component';
import { AdmCatalogosGestionComponent } from './adm-catalogos-gestion/adm-catalogos-gestion.component';
import { BreadcrumbModule } from 'src/app/_layout/breadcrumb/breadcrumb.module';
import { AdmEgresadosGestionComponent } from './adm-egresados-gestion/adm-egresados-gestion.component';
import { AdmDocentesGestionComponent } from './adm-docentes-gestion/adm-docentes-gestion.component';
import { AdmAdminsGestionComponent } from './adm-admins-gestion/adm-admins-gestion.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdmAdminsListComponent } from './adm-admins-list/adm-admins-list.component';
import { AdmDocentesListComponent } from './adm-docentes-list/adm-docentes-list.component';
import { AdmEgresadosListComponent } from './adm-egresados-list/adm-egresados-list.component';
import { AdmModalValidarofertaComponent } from './adm-modal-validaroferta/adm-modal-validaroferta.component';
import { AdmEmpresaNuevaComponent } from './adm-empresa-nueva/adm-empresa-nueva.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { AdmModalValidarofertasEmpresaComponent } from './adm-modal-validarofertas-empresa/adm-modal-validarofertas-empresa.component';

@NgModule({
  declarations: [
    AdmDashboardComponent,
    AdmOfertasListaComponent,
    AdmOfertasDetallesComponent,
    AdmOfertasActivasComponent,
    AdmEmpresasListaComponent,
    AdmEmpresasOfdetalleComponent,
    AdmCatalogosGestionComponent,
    AdmEgresadosGestionComponent,
    AdmDocentesGestionComponent,
    AdmAdminsGestionComponent,
    AdmAdminsListComponent,
    AdmDocentesListComponent,
    AdmEgresadosListComponent,
    AdmModalValidarofertaComponent,
    AdmEmpresaNuevaComponent,
    AdmModalValidarofertasEmpresaComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    CardModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    BreadcrumbModule,
    FormsModule,
    UiSwitchModule,
    BlockUIModule.forRoot({
      template: BlockTemplateComponent
    }),
    RouterModule.forChild([
      {
        path: 'dashboard',
        component: AdmDashboardComponent
      },
      {
        path: 'ofertas',
        component: AdmOfertasListaComponent
      },
      {
        path: 'ofertas/detalle',
        component: AdmOfertasDetallesComponent
      },
      {
        path: 'ofertas-activas',
        component: AdmOfertasActivasComponent
      },
      {
        path: 'empresas',
        component: AdmEmpresasListaComponent
      },
      {
        path: 'empresas/crear-cuenta',
        component: AdmEmpresaNuevaComponent
      },
      {
        path: 'empresa/detalles',
        component: AdmEmpresasOfdetalleComponent
      },
      {
        path: 'gestion',
        component: AdmCatalogosGestionComponent
      },
      {
        path: 'egresados',
        component: AdmEgresadosGestionComponent
      },
      {
        path: 'docentes',
        component: AdmDocentesGestionComponent
      },
      {
        path: 'administradores',
        component: AdmAdminsGestionComponent
      },
      {
        path: 'lista-administradores',
        component: AdmAdminsListComponent
      },
      {
        path: 'lista-docentes',
        component: AdmDocentesListComponent
      },
      {
        path: 'lista-egresados',
        component: AdmEgresadosListComponent
      },
    ])
  ],
  exports: [RouterModule]
})
export class AdminModule { }
